import React from "react";
import { useField } from "react-final-form";

const FieldError = ({
  field_name,
  returningToPage,
  returningToForm,
  currentErrors,
}) => {
  let field = field_name || "_";
  const {
    meta: { touched, error },
  } = useField(field, {
    subscription: { touched: true, error: true },
  });

  // if object don't render
  const isObject = typeof error === "object";
  let showError = returningToPage || (touched && error) || returningToForm;
  return showError && !isObject ? (
    <span className={`usa-error-message`}>
      {error && error !== undefined
        ? error
        : currentErrors &&
          currentErrors !== undefined &&
          currentErrors[field_name] &&
          typeof currentErrors[field_name] === "string"
        ? currentErrors[field_name]
        : ""}
    </span>
  ) : null;
};

export default FieldError;
